module.exports = __webpack_public_path__ + "static/media/L4.a2ffe21f.jpg";